function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { makeStyles } from '@material-ui/core/styles';
import colors from "../../foundations/colors.module.scss";
import { baseMenuItemStyles } from "../Menu/Menu.styles";
const isMultiline = p => p.variant === 'multiline';
export const useMenuItemStyles = makeStyles({
  root: _objectSpread(_objectSpread({}, baseMenuItemStyles), {}, {
    height: p => isMultiline(p) ? 'auto' : p.height || 40,
    whiteSpace: p => isMultiline(p) ? 'normal' : 'nowrap',
    display: p => isMultiline(p) ? 'block' : 'flex'
  }),
  secondary: {
    color: "".concat(colors.dark700, " !important"),
    // necessary in case the item is an <a> element since old UI lib take over global link styles
    '&:hover': {
      color: "".concat(colors.dark900, " !important")
    },
    // Target Material-UI Typography
    '& .MuiTypography-root': {
      color: 'inherit !important'
    },
    // Target custom Typography component - force all children to inherit color
    // This ensures Typography components always inherit the menu item color
    '& > *': {
      color: 'inherit !important'
    }
  },
  error: {
    color: "".concat(colors.red950, " !important"),
    // necessary in case the item is an <a> element since old UI lib take over global link styles
    '&:hover': {
      color: "".concat(colors.red970, " !important")
    },
    // Target Material-UI Typography
    '& .MuiTypography-root': {
      color: 'inherit !important'
    },
    // Target custom Typography component - force all children to inherit color
    // This ensures Typography components always inherit the menu item color
    '& > *': {
      color: 'inherit !important'
    }
  }
});